// extracted by mini-css-extract-plugin
export default {"option":"Option__option--c3z1G","highlighted":"Option__highlighted--B2INn"};